import { useContext } from 'react';

import { FwTemplatesContext } from './FwTemplatesContext';

const useFwTemplates = () => useContext(FwTemplatesContext);

export { useFwTemplates };
